/** @jsxImportSource @emotion/react */
import { MutableRefObject, useEffect, useRef } from "react";
import Sortable from "sortablejs";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  onEnd: (
    event: Sortable.SortableEvent,
    containerRef: MutableRefObject<HTMLElement | null>
  ) => void;
  containerStyle?: any;
  isTable?: boolean;
}

export const DragAndDropContainer = ({
  onEnd,
  containerStyle,
  children,
  isTable = false,
  ...rest
}: Props) => {
  const containerRef = useRef<HTMLElement | null>(null);
  const sortableJsRef = useRef<Sortable | null>(null);

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }
    // Making the grid sortable. Library: https://github.com/SortableJS/Sortable
    sortableJsRef.current = new Sortable(containerRef.current, {
      animation: 150,
      onEnd: (event) => {
        if (!containerRef) {
          return;
        }
        onEnd(event, containerRef);
      },
    });
  }, [onEnd]);

  if (isTable) {
    return (
      <tbody
        css={containerStyle}
        ref={containerRef as MutableRefObject<HTMLTableSectionElement | null>}
      >
        {children}
      </tbody>
    );
  }

  return (
    <div
      css={containerStyle}
      ref={containerRef as MutableRefObject<HTMLDivElement | null>}
      {...rest}
    >
      {children}
    </div>
  );
};
